import { render, staticRenderFns } from "./gift_list.vue?vue&type=template&id=ff1e974e"
import script from "./gift_list.vue?vue&type=script&lang=js"
export * from "./gift_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1e974e')) {
      api.createRecord('ff1e974e', component.options)
    } else {
      api.reload('ff1e974e', component.options)
    }
    module.hot.accept("./gift_list.vue?vue&type=template&id=ff1e974e", function () {
      api.rerender('ff1e974e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/meeting_affair_charge/form/gift_list.vue"
export default component.exports